exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#secondFooterContainer[data-v-99252502]{padding-top:10px;padding-bottom:0}#copyrightText[data-v-99252502]{text-align:left;font-family:inherit;font-size:16px;color:#fff;margin-left:10px;margin-top:30px;margin-bottom:16px;max-width:780px}#secondFooter[data-v-99252502]{background-color:#181818}", ""]);

// exports
